import * as THREE from "three";
import RAPIER from "@dimforge/rapier3d-compat";

export class PhysicsWorld
{
  private static readonly BASE_GRAVITY = 9.81;

  private static readonly GRAVITY_SCALE = 1.2;
  public static readonly GRAVITY = PhysicsWorld.BASE_GRAVITY * PhysicsWorld.GRAVITY_SCALE;

  private static world: RAPIER.World;
  private static pre_step_hook: ( ( dt: number ) => void ) | null = null;

  public static async init()
  {
    await RAPIER.init();

    this.world = new RAPIER.World( {
      x: 0,
      y: -PhysicsWorld.GRAVITY,
      z: 0
    } );

    console.log( "Rapier initialized" );
  }

  static createFixedBox(
    pos: THREE.Vector3,
    size: THREE.Vector3
  )
  {
    const body = this.world.createRigidBody(
      RAPIER.RigidBodyDesc.fixed()
        .setTranslation( pos.x, pos.y, pos.z )
    );

    this.world.createCollider(
      RAPIER.ColliderDesc.cuboid(
        size.x / 2,
        size.y / 2,
        size.z / 2
      ),
      body
    );

    return body;
  }

  public static setPreStepHook( hook: ( ( dt: number ) => void ) | null ): void
  {
    this.pre_step_hook = hook;
  }

  public static hook_ms = 0;
  public static step_ms = 0;

  public static resetTimers(): void
  {
    this.hook_ms = 0;
    this.step_ms = 0;
  }

  public static update( dt: number )
  {
    const t0 = performance.now();
    this.pre_step_hook?.( dt );

    const t1 = performance.now();
    this.world.timestep = dt;
    this.world.step();

    const t2 = performance.now();
    PhysicsWorld.hook_ms += t1 - t0;
    PhysicsWorld.step_ms += t2 - t1;
  }

  public static counts(): { bodies: number; colliders: number; awake: number }
  {
    let awake = 0;
    this.world.forEachRigidBody( body =>
    {
      if ( !body.isSleeping() && body.isDynamic() )
        awake++;
    } );

    return {
      bodies: this.world.bodies.len(),
      colliders: this.world.colliders.len(),
      awake,
    };
  }

  public static setFastMode( fast: boolean ): void
  {
    this.world.numSolverIterations = fast ? 2 : 4;
  }

  public static getWorld()
  {
    return this.world;
  }
}
